<template>
  <el-card class="card linkUnlockCard" data-section-id="unlock">
    <div slot="header" class="linkUnlockCard__header">
      <strong class="linkUnlockCard__title">关联解锁组</strong>
      <span
        v-if="showCompletionStatus"
        class="linkUnlockCard__status"
        :class="completionDone ? 'linkUnlockCard__status--done' : 'linkUnlockCard__status--pending'"
      >
        {{ completionDone ? '✓ 已完成' : '未完成' }}
      </span>
    </div>
    <div>
      <el-form
        size="small"
        :model="unlockData"
        :rules="rules"
        ref="ruleFormRef"
      >
        <el-form-item label="默认解锁组" prop="defaultLockGroupId" required data-field-key="defaultLockGroupId">
          <el-select
            v-model="unlockData.defaultLockGroupId"
            placeholder="请选择默认解锁组"
            filterable
            clearable
            class="linkUnlockCard__select"
          >
            <el-option
              v-for="item in defaultUnlockOptions"
              :key="item.id"
              :label="item.groupName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <div class="linkUnlockCard__datasetBlock">
          <p class="linkUnlockCard__datasetLabel">数据集解锁条件（选填）</p>
          <div
            v-for="(item, index) in unlockData.dataSetLockGroupList"
            :key="'dataset-lock-' + index"
            class="linkUnlockCard__datasetRow"
          >
            <el-select
              v-model="item.lockGroupId"
              placeholder="解锁方式"
              filterable
              clearable
              class="linkUnlockCard__select"
            >
              <el-option
                v-for="opt in defaultUnlockOptions"
                :key="'lock-' + opt.id"
                :label="opt.groupName"
                :value="opt.id"
              />
            </el-select>
            <el-select
              v-model="item.dataSetId"
              placeholder="数据集"
              filterable
              clearable
              class="linkUnlockCard__select"
            >
              <el-option
                v-for="opt in dataOptions"
                :key="'data-' + opt.id"
                :label="opt.name"
                :value="opt.id"
              />
            </el-select>
            <button
              type="button"
              class="linkUnlockCard__deleteBtn"
              aria-label="删除解锁条件"
              @click="deleteUnlockType(index)"
            >
              删除
            </button>
          </div>
          <button type="button" class="linkUnlockCard__addBtn" @click="addUnlockType">
            <i class="el-icon-plus" aria-hidden="true" />
            添加解锁条件
          </button>
        </div>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import { getLockGroupList } from '../api/unlockGroup'
import { getAllDataList } from '../api/classifyManage'

export default {
  name: 'unlockCard',
  props: {
    unlockData: {
      type: Object,
      default() {
        return {
          defaultLockGroupId: '',
          dataSetLockGroupList: [{ lockGroupId: '', dataSetId: '' }],
        }
      },
    },
    showCompletionStatus: {
      type: Boolean,
      default: false,
    },
    completionDone: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.getAllData()
    this.getAllUnlock()
  },
  data() {
    return {
      defaultUnlockOptions: [],
      dataOptions: [],
      rules: {
        defaultLockGroupId: [
          {
            required: true,
            message: '默认关联解锁组不能为空',
            trigger: ['change'],
          },
        ],
      },
    }
  },
  methods: {
    validate(callback) {
      this.$refs.ruleFormRef.validate((valid) => {
        callback(valid)
      })
    },
    addUnlockType() {
      this.unlockData.dataSetLockGroupList.push({
        lockGroupId: '',
        dataSetId: '',
      })
    },
    deleteUnlockType(index) {
      if (this.unlockData.dataSetLockGroupList.length <= 1) {
        this.unlockData.dataSetLockGroupList.splice(index, 1, {
          lockGroupId: '',
          dataSetId: '',
        })
        return
      }
      this.unlockData.dataSetLockGroupList.splice(index, 1)
    },
    getAllData() {
      getAllDataList().then((res) => {
        if (res.success) {
          this.dataOptions = res.data
        }
      })
    },
    getAllUnlock() {
      getLockGroupList(
        { pageNum: '', pageSize: '', groupName: '', lockGroupType: '' },
        0
      ).then((res) => {
        if (res.success) {
          this.defaultUnlockOptions = res.data
        }
      })
    },
  },
}
</script>

<style scoped>
.card {
  margin-bottom: 20px;
}

.linkUnlockCard__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.linkUnlockCard__title {
  font-size: 14px;
}

.linkUnlockCard__status {
  font-size: 12px;
  font-weight: 500;
}

.linkUnlockCard__status--pending {
  color: #d97706;
}

.linkUnlockCard__status--done {
  color: #16a34a;
}

.linkUnlockCard__select {
  width: 100%;
}

.linkUnlockCard__datasetBlock {
  margin-top: 4px;
}

.linkUnlockCard__datasetLabel {
  margin: 0 0 10px;
  font-size: 12px;
  color: var(--link-ink-secondary, #57534e);
}

.linkUnlockCard__datasetRow {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  margin-bottom: 8px;
}

.linkUnlockCard__deleteBtn {
  padding: 0 4px;
  border: none;
  background: none;
  font-size: 12px;
  color: #dc2626;
  cursor: pointer;
  white-space: nowrap;
}

.linkUnlockCard__addBtn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  padding: 0;
  border: none;
  background: none;
  font-size: 12px;
  color: var(--link-accent, #2563eb);
  cursor: pointer;
}
</style>
